// GalleryImage.jsx (эсвэл .tsx)
import React, { useMemo } from "react";

// URL-д builder.io параметрүүд нэмэх util
function withParams(url, params = {}) {
  const u = new URL(url);
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    u.searchParams.set(k, String(v));
  });
  return u.toString();
}

/**
 * Хурдан <picture>:
 * - AVIF/WebP эхэнд, JPG/PNG fallback
 * - srcSet + sizes → responsive
 * - lazy + decoding="async"
 */
export function GalleryImage({
  src,
  alt = "",
  className = "",
  priority = false, // above-the-fold бол true болго
  widths = [480, 768, 1024, 1440, 1920],
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw",
  quality = 70,
}) {
  const avifSet = useMemo(
    () =>
      widths
        .map(
          (w) => `${withParams(src, { format: "avif", width: w, quality })} ${w}w`
        )
        .join(", "),
    [src, widths, quality]
  );

  const webpSet = useMemo(
    () =>
      widths
        .map(
          (w) => `${withParams(src, { format: "webp", width: w, quality })} ${w}w`
        )
        .join(", "),
    [src, widths, quality]
  );

  const fallbackSet = useMemo(
    () =>
      widths
        .map(
          (w) => `${withParams(src, { width: w, quality })} ${w}w`
        )
        .join(", "),
    [src, widths, quality]
  );

  const fallbackSrc = withParams(src, { width: 1024, quality });

  return (
    <picture>
      <source type="image/avif" srcSet={avifSet} sizes={sizes} />
      <source type="image/webp" srcSet={webpSet} sizes={sizes} />
      <img
        src={fallbackSrc}
        srcSet={fallbackSet}
        sizes={sizes}
        alt={alt}
        className={className}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "low"}
        decoding="async"
      />
    </picture>
  );
}
